import { render, staticRenderFns } from "./FreeTextQuestion.vue?vue&type=template&id=e2622e9a&scoped=true&lang=pug"
import script from "./FreeTextQuestion.vue?vue&type=script&lang=ts"
export * from "./FreeTextQuestion.vue?vue&type=script&lang=ts"
import style0 from "./FreeTextQuestion.vue?vue&type=style&index=0&id=e2622e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2622e9a",
  null
  
)

export default component.exports